import { z } from 'zod';

export const instrumentRowSchema = z
  .object({
    tenor: z
      .string()
      .optional()
      .transform((v) => v ?? ''),
    notional: z
      .string()
      .optional()
      .transform((v) => v ?? ''),
    deltaOrStrike: z
      .string()
      .optional()
      .transform((v) => v ?? ''),
  })
  .superRefine((data, ctx) => {
    const fields = [data.tenor, data.notional, data.deltaOrStrike];
    const filledFields = fields.filter((f) => f && f.trim());

    if (filledFields.length > 0 && filledFields.length < 3) {
      if (!data.tenor || !data.tenor.trim()) {
        ctx.addIssue({
          path: ['tenor'],
          code: z.ZodIssueCode.custom,
          message: 'Tenor is required when any field is filled',
        });
      }
      if (!data.notional || !data.notional.trim()) {
        ctx.addIssue({
          path: ['notional'],
          code: z.ZodIssueCode.custom,
          message: 'Notional is required when any field is filled',
        });
      }
      if (!data.deltaOrStrike || !data.deltaOrStrike.trim()) {
        ctx.addIssue({
          path: ['deltaOrStrike'],
          code: z.ZodIssueCode.custom,
          message: 'Delta or Strike is required when any field is filled',
        });
      }
    }
  });

export const portfolioSchema = z.object({
  instruments: z.array(instrumentRowSchema),
});

export type PortfolioSchemaType = z.infer<typeof portfolioSchema>;
export type InstrumentRowSchemaType = z.infer<typeof instrumentRowSchema>;
